import { render, staticRenderFns } from "./CheckFile.vue?vue&type=template&id=31cbbdd2&"
import script from "./CheckFile.vue?vue&type=script&lang=js&"
export * from "./CheckFile.vue?vue&type=script&lang=js&"
import style0 from "./CheckFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports